'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGWrapper = require('./SVGWrapper');

var _SVGWrapper2 = _interopRequireDefault(_SVGWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVGImage = function SVGImage(props) {
  return _react2.default.createElement(_SVGWrapper2.default, props);
};

SVGImage.propTypes = {
  image: _react.PropTypes.string
};

exports.default = SVGImage;
module.exports = exports['default'];